const USER_SHIFT_TYPE = {
  // user shift type
  POST_USER_SHIFT_TYPES_SUCCESS: "POST_USER_SHIFT_TYPES_SUCCESS",
  POST_USER_SHIFT_TYPES: "POST_USER_SHIFT_TYPES",
  POST_USER_SHIFT_TYPES_FAIL: "POST_USER_SHIFT_TYPES_FAIL",

  //delete shift type
  DELETE_USER_SHIFT_TYPES_SUCCESS: "DELETE_USER_SHIFT_TYPES_SUCCESS",
  DELETE_USER_SHIFT_TYPES: "DELETE_USER_SHIFT_TYPES",
  DELETE_USER_SHIFT_TYPES_FAIL: "DELETE_USER_SHIFT_TYPES_FAIL",

  // insert shift
  INSERT_SHIFT_TYPES: "INSERT_SHIFT_TYPES",
  INSERT_SHIFT_TYPES_SUCCESS: "INSERT_SHIFT_TYPES_SUCCESS",
  INSERT_SHIFT_TYPES_FAIL: "INSERT_SHIFT_TYPES_FAIL",

  //get user shift type by token
  GET_USER_SHIFT_TYPES_BY_TOKEN: "GET_USER_SHIFT_TYPES_BY_TOKEN",
  GET_USER_SHIFT_TYPES_BY_TOKEN_SUCCESS:
    "GET_USER_SHIFT_TYPES_BY_TOKEN_SUCCESS",

  //leave shift type
  LEAVE_USER_SHIFT_TYPES_SUCCESS: "LEAVE_USER_SHIFT_TYPES_SUCCESS",
  LEAVE_USER_SHIFT_TYPES: "LEAVE_USER_SHIFT_TYPES",
  LEAVE_USER_SHIFT_TYPES_FAIL: "LEAVE_USER_SHIFT_TYPES_FAIL",

  //get user's shift today
  GET_TODAY_USER_SHIFT_TYPES: "GET_TODAY_USER_SHIFT_TYPES",
  GET_TODAY_USER_SHIFT_TYPES_SUCCESS: "GET_TODAY_USER_SHIFT_TYPES_SUCCESS",
  GET_TODAY_USER_SHIFT_TYPES_FAIL: "GET_TODAY_USER_SHIFT_TYPES_FAIL",
};
export default USER_SHIFT_TYPE;
